import { render, staticRenderFns } from "./Lifespan.vue?vue&type=template&id=eccffb2a&scoped=true"
import script from "./Lifespan.vue?vue&type=script&lang=js"
export * from "./Lifespan.vue?vue&type=script&lang=js"
import style0 from "./Lifespan.vue?vue&type=style&index=0&id=eccffb2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccffb2a",
  null
  
)

export default component.exports